var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"1400px"}},[_c('v-form',{model:{value:(_vm.formValid),callback:function ($$v) {_vm.formValid=$$v},expression:"formValid"}},[(_vm.schema)?_c('v-jsonschema-form',{attrs:{"schema":_vm.schema,"model":_vm.dataObject_edit,"options":_vm.options}}):_vm._e(),_vm._v(" "),_c('v-btn',{on:{"click":_vm.savegroup}},[_vm._v("submit")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/pages/servers/edit.vue?vue&type=template&id=03a340e0&
// module id = null
// module chunks = 